import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { getFullDisplayableWholeSalers } from '../../../components/Navigation/Footer/whole-sale-sorter.js'
import {
  getAuthManagerInstance,
  isLoggedIn,
  isInstitutional,
} from '../../../global/authentication/authentication-manager.js'
import { getWholesalerFromcookies } from './utils.js'

const hideFooterContent = () => {
  const footerContent = document.getElementById('footer-default-content')
  footerContent?.classList?.add('u-hidden')
}

const Wholesaler = (props) => {
  const defaultState = {
    backgroundColor: props.backgroundColor === 'Gray' ? 'u-bgColorLight' : null,
    hideFooterContent: false,
    displayNoConsultant: true,
  }
  let [state] = useState(defaultState)
  let [wholesalers, setWholesalers] = useState(undefined)

  useEffect(() => {
    if (isInstitutional()) {
      const RM_data = getWholesalerFromcookies()
      const contactInfoExists =
        RM_data?.preferredFirstNm && RM_data?.emailId && RM_data?.phoneNbr
      if (contactInfoExists && state.hideFooterContent) {
        hideFooterContent()
      }

      const wholsalerData = contactInfoExists ? [RM_data] : []
      setWholesalers(wholsalerData)
    } else {
      if (isLoggedIn()) {
        getAuthManagerInstance()
          .getProfileServiceBehaviorSubject()
          .subscribe((profile) => {
            const results = getFullDisplayableWholeSalers(profile)
            const wholesalersExist = results && results.length
            const wholesalerData = wholesalersExist ? results : []
            if (wholesalersExist && state.hideFooterContent) {
              hideFooterContent()
            }
            setWholesalers(wholesalerData)
          })
      }
    }
  }, [])

  const getRenderedWholesaler = (wholesaler, index) => {
    const {
      preferredFirstNm,
      preferredLastNm,
      titleCd,
      designationCd,
      phoneNbr,
      emailId,
      photoURL,
    } = wholesaler

    return (
      <React.Fragment key={`footerWholeSaler` + index}>
        <div className="u-size1of2 u-sm-sizeFull Grid">
          {!isInstitutional() && (
            <div className="u-sm-sizeFull u-md-size1of3 u-lg-size1of3 u-sm-marginBottom5gu u-sm-flex u-flexJustifyCenter u-bgColorWhite">
              <img
                className="u-sm-size1of2 u-md-sizeFull u-lg-sizeFull"
                src={
                  photoURL
                    ? photoURL
                    : '/binaries/content/gallery/cti-blog/imported/cti-blank-profile.jpg/cti-blank-profile.jpg'
                }
                alt={preferredFirstNm}
                data-qa-automation="wholesaler-image"
                height={220}
                width={178}
              />
            </div>
          )}
          <div
            className={`${
              index === 0
                ? `u-sm-marginBottom5gu ${
                    isInstitutional()
                      ? 'u-md-sizeFull u-lg-sizeFull'
                      : 'u-md-size2of3 u-lg-size2of3 u-paddingLeft4gu u-md-paddingLeft4gu u-sm-paddingHoriz1gu'
                  }`
                : 'u-md-size2of3 u-lg-size2of3 u-paddingLeft4gu u-md-paddingLeft4g u-sm-paddingHoriz1gu'
            }`}
          >
            <div className="col-bottom-txt">
              <div className="bottom-txt">
                <h3
                  className={`u-textSecondary u-textColorBrand Footer-wholesalerTitle`}
                >
                  {preferredFirstNm} {preferredLastNm}
                  {designationCd && (
                    <React.Fragment>
                      , <span>{designationCd}</span>
                    </React.Fragment>
                  )}
                </h3>
                <p className="u-marginBottom2gu Footer-wholesalerText">
                  {titleCd}
                </p>
                <dl className="List List--definition">
                  <div className="List-item u-decoBorderLight">
                    <dt className="List-itemLabel">
                      Speak with {preferredFirstNm}{' '}
                    </dt>
                    <dd className="List-itemValue u-textRight">
                      <a href={`tel:${phoneNbr}`} className="Link">
                        {phoneNbr}
                      </a>
                    </dd>
                  </div>
                  <div className="List-item u-decoBorderLight u-decoBorderResetTop">
                    <dt className="List-itemLabel">
                      Email {preferredFirstNm}{' '}
                    </dt>
                    <dd className="List-itemValue u-textRight u-flex u-flexAlignItemsCenter u-flexJustifyEnd">
                      <span className="Icon--material u-textSizeMsrp1 u-textColorBrand u-marginRight1gu">
                        mail
                      </span>
                      <a
                        className="Link Footer-wholesalerLink"
                        href={
                          isInstitutional()
                            ? `mailto:${emailId}`
                            : `/about/contact-us/sc/email?emailId=${emailId}`
                        }
                      >
                        Send a Message
                      </a>
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }

  const displayNoConsultantMessage = () => {
    if (isLoggedIn()) {
      const consultantTeamButton = document.getElementById(
        'consultant-team-button'
      )
      consultantTeamButton?.classList?.add('u-hidden')

      return (
        <div className="Footer-alert alert alert-info u-decoBackgroundWhite u-paddingLeft4gu u-paddingVert3gu u-marginTop1gu u-marginBottom5gu u-sizeConstrained">
          <p className="u-textColorEstefan">
            <b>
              We&apos;re sorry. Your consultant team information is not
              available,{' '}
            </b>
            but we&apos;re still here to help. Please call the National Sales
            Desk at 800.426.3750 for assistance.
          </p>
        </div>
      )
    }
  }

  function renderFunctionalAreaTemplate(area) {
    return (
      <div
        key={area.functionalAreaNm}
        className="u-paddingVert12gu u-decoBorderLight u-decoBorderResetTop u-sm-paddingVert6gu u-sm-decoBorderReset"
      >
        <h2 className="u-marginBottom6gu">{area.functionalAreaNm}</h2>
        <div className="Grid Grid--equalHeight">
          {area &&
            area.salesContactInfo &&
            area.salesContactInfo.map((consultant, index) => {
              return getRenderedWholesaler(consultant, index)
            })}
        </div>
      </div>
    )
  }

  const { backgroundColor, displayNoConsultant } = state
  return wholesalers?.length > 0 ? (
    <div className={backgroundColor}>
      <div className="Grid u-marginBottom4gu u-sizeConstrained">
        {wholesalers?.length > 0 &&
          wholesalers.map((area) => renderFunctionalAreaTemplate(area))}
      </div>
    </div>
  ) : displayNoConsultant ? (
    <React.Fragment>{displayNoConsultantMessage()}</React.Fragment>
  ) : null
}

Wholesaler.propTypes = {
  backgroundColor: PropTypes.string,
}
export default Wholesaler
